/**
 * Item 48 (acessibilidade, WCAG 2.4.1): o primeiro foco da página. Quem navega pelo teclado ou por leitor de tela pula
 * o menu e o topo, que se repetem em toda tela. Fica fora da vista até receber o foco.
 *
 * <p>O clique leva o foco ao alvo SEM mudar o endereço: o "#alvo" no endereço viraria uma navegação do roteador. O
 * alvo precisa de {@code tabIndex={-1}} para aceitar o foco.
 */
export function PularParaConteudo({ alvo }: { alvo: string }): JSX.Element {
  return (
    <a
      className="pular-para-conteudo"
      href={'#' + alvo}
      onClick={(e) => {
        const destino = document.getElementById(alvo);
        if (!destino) return;
        e.preventDefault();
        destino.focus();
      }}
    >
      Ir para o conteúdo
    </a>
  );
}
